import React, { useEffect } from "react";
import {
  Page,
  SubmitButton,
  required,
  FormGroup,
  DatePicker,
} from "components/common";
import { Control, actions } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";

export const PublicHolidayEdit = ({
  payroll,
  t,
  url = "public_holidays",
  model = "local",
  history,
  match,
}) => {
  const { dispatch, setValue, Form, save, loaded, load, getTitle } = useForm({
    model,
  });
  const { id } = match.params;

  async function onSubmit(item) {
    try {
      await save(payroll, url, item);
      NotificationManager.success(t("Saved successfully"));
      history.replaceUp();
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }

  useEffect(
    () =>
      void (async () => {
        const item = await load(payroll, url, id, {});
        setValue(item);
      })(),
    [id]
  );

  if (!loaded) return null;

  return (
    <Page title={getTitle(id, "Public Holiday")}>
      <Form
        onSubmit={onSubmit}
        validators={{
          name: { required },
          date: { required },
        }}
      >
        <FormGroup label="Name *" model=".name">
          <Control.text model=".name" />
        </FormGroup>
        <FormGroup label="Date *" model=".date">
          <DatePicker model=".date" className="form-control" />
        </FormGroup>
        <div className="d-flex justify-content-end">
          <SubmitButton>Save</SubmitButton>
        </div>
      </Form>
    </Page>
  );
};

export default PublicHolidayEdit;
